// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  petitionId: __t.u64().primaryKey().name("petition_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  mayorId: __t.u64().name("mayor_id"),
  reason: __t.string(),
  signatures: __t.u32(),
  votesFor: __t.u32().name("votes_for"),
  votesAgainst: __t.u32().name("votes_against"),
  status: __t.string(),
  openedAt: __t.timestamp().name("opened_at"),
  decidedAt: __t.timestamp().name("decided_at"),
});
